import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useDispatch, useSelector } from 'react-redux';
import {
  setColoniasAction,
  setLoadingColoniasAction,
  setLoadingMunicipiosAction,
  setMunicipiosAction,
} from 'redux/actions/emision/catalogos.actions';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { mapArrayDropdownOptions } from 'utils/funciones';

const useCatalogos = (prodCodigo = PRODUCTOS.TRAVELBTA) => {
  const state = useSelector((state) => state.EmisionCatalogosReducer);

  const dispatch = useDispatch();

  const findMunicipios = async (codPais, codDpto) => {
    dispatch(setLoadingMunicipiosAction(true));
    if (codPais && codDpto) {
      const Data = {
        datosCotizador: {
          prodCodigo,
          cotPasoCodigo: 'municipios',
          codPais,
          codDpto,
        },
      };
      const res = await ApiKeyFetch.instance().post(URLS_PHP_7.emision.datosEmision, Data);
      console.log('RES: ', res);
      const data = res?.catalogo?.municipios?.map?.(mapArrayDropdownOptions) || [];

      dispatch(setMunicipiosAction(data));

      dispatch(setLoadingMunicipiosAction(false));
      return data;
    }
    dispatch(setLoadingMunicipiosAction(false));
    return [];
  };

  const setMunicipios = (municipios = []) => {
    dispatch(setMunicipiosAction(municipios));
  };

  const findColonias = async ({ codPais, codDpto, codMunicipio }) => {
    dispatch(setLoadingColoniasAction(true));

    if (codPais && codDpto && codMunicipio) {
      const Data = {
        datosCotizador: {
          prodCodigo,
          cotPasoCodigo: 'colonias',
          codPais,
          codDepartamento: codDpto,
          codMunicipio,
        },
      };
      const res = await ApiKeyFetch.instance().post(URLS_PHP_7.emision.datosEmision, Data);
      const data = res?.catalogo?.colonias?.map(mapArrayDropdownOptions) || [];
      dispatch(setColoniasAction(data));
      dispatch(setLoadingColoniasAction(false));
      return data;
    }
    dispatch(setLoadingColoniasAction(false));
    return [];
  };

  const setColonias = (colonias = []) => {
    dispatch(setColoniasAction(colonias));
  };

  return { ...state, findMunicipios, setMunicipios, findColonias, setColonias };
};

export default useCatalogos;
